export const INT_TRUE = 1;
export const INT_FALSE = 0;

export const INT_TIPO_USUARIO = {
    REFUGIO: 2,
    PUBLICIDAD: 3,
    REFUGIO_Y_PUBLICIDAD: 4,
};

export const INT_VERTICAL_IMAGE = {
    BIG: 6,
    MEDIUM: 7,
    SMALL: 8,
};

export const INT_HORIZONTAL_IMAGE = {
    BIG: 11,
    MEDIUM: 10,
    SMALL: 9,
};